export const CCDKC_DASHBOARD = 'dashboard';
export const CCDKC_CONTRACTS_LIST = 'contracts';
export const CCDKC_USER_MANAGEMENT = 'user-management';
export const CCDKC_PLANNING = 'planning';
export const CCDKC_PLANNING_HISTORY = 'planninghistory';
export const CCDKC_PLANNING_HISTORY_DETAIL = 'detail';
export const CCDKC_PLANNING_LIST = 'list';
export const CCDKC_CENTER_APPOINTMENTS = 'center-appointments';
export const CCDKC_MAKE_APPOINTMENT = 'make-appointment';
export const CCDKC_EDIT_APPOINTMENT = 'edit-appointment';
